import React, { lazy, Suspense, useEffect } from 'react';
import { Switch, useLocation } from 'react-router-dom';
import { ROUTES } from '../constants';
import GuestRoute from './GuestRoute';
import HomePage from '../pages/HomePage';
import NotFoundPage from '../pages/NotFoundPage';

const GameDetailPage = lazy(() => import('src/pages/GameDetailPage'));

function LazyGameDetail(props) {
  return (
    <Suspense fallback={<div />}>
      <GameDetailPage {...props} />
    </Suspense>
  );
}

// Scroll back to the top whenever the route changes. Without this, clicking
// a game card from mid-page lands you on /game/<code> still scrolled down.
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
}

function Routes() {
  return (
    <>
      <ScrollToTop />
      <Switch>
        <GuestRoute
          exact
          path={ROUTES.ROOT_PATH}
          component={HomePage}
        />
        <GuestRoute
          path="/game/:code"
          component={LazyGameDetail}
        />
        <GuestRoute
          path="*"
          component={NotFoundPage}
        />
      </Switch>
    </>
  );
}

export default Routes;
